// Swedish (Svenska)
export default {
  nav: {
    home: 'Startsida',
    wall: 'Väggen',
    groups: 'Grupper',
    users: 'Användare',
    profile: 'Min profil',
    help: 'Hjälp',
    membership: 'Medlemskap',
    logout: 'Logga ut',
    login: 'Logga in'
  },
  auth: {
    loginSubtitle: 'Logga in för att fortsätta',
    email: 'E-post',
    password: 'Lösenord',
    noAccount: 'Har du inget konto?',
    createAccount: 'Skapa konto',
    loginFailed: 'Inloggningen misslyckades. Kontrollera din e-post och ditt lösenord.',
    alreadyHaveAccount: 'Har du redan ett konto?',
    register: 'Registrera',
    name: 'Namn',
    confirmPassword: 'Bekräfta lösenord',
    registrationSuccess: 'Konto skapat! Du kan nu logga in.',
    registrationFailed: 'Kunde inte skapa konto.'
  },
  home: {
    title: 'Gemenskap',
    tagline: 'En lugn plats på nätet – utan reklam.',
    description: 'Dela vardagen med familj, vänner och nya bekanta. Inget brus, ingen spårning, ingen dataförsäljning.',
    features: {
      noAds: 'Reklamfri',
      simple: 'Enkel och tydlig',
      safe: 'Trygg ton + moderering'
    },
    cta: {
      openWall: 'Öppna Väggen',
      createProfile: 'Skapa gratis profil',
      goToWall: 'Gå till Väggen',
      readMore: 'Läs om idén'
    },
    pricing: 'Sidan är gratis att använda.',
    pricingDetail: 'Men även vi behöver leva – vänligen överväg att donera.'
  },
  wall: {
    title: 'Väggen',
    subtitle: 'Här ser du inlägg från gemenskapen.',
    writePost: 'SKRIV PÅ VÄGGEN',
    placeholder: 'Skriv ditt inlägg här...',
    group: 'Grupp',
    noGroup: 'Ingen grupp',
    selectImage: 'Välj bild',
    noFileSelected: 'Ingen fil vald.',
    send: 'Skicka',
    public: 'Offentligt',
    members: 'Medlemmar',
    private: 'Privat',
    visibility: 'Synlighet'
  },
  groups: {
    title: 'Grupper',
    subtitle: 'Grupper som ger mening – lokalt, hobby, resor, promenader – lätt att följa med.',
    createGroup: 'Skapa grupp',
    allGroups: 'Alla grupper',
    myGroups: 'Mina grupper',
    searchPlaceholder: 'Sök grupper...',
    noGroups: 'Inga grupper hittades',
    noMyGroups: 'Du är inte medlem i några grupper ännu',
    groupName: 'Gruppnamn',
    description: 'Beskrivning',
    publicGroup: 'Offentlig grupp (alla kan se och gå med)',
    private: 'Privat',
    createdBy: 'Skapad av',
    members: 'medlemmar',
    postsCount: 'inlägg',
    noDescription: 'Ingen beskrivning',
    join: 'Gå med',
    leave: 'Lämna',
    open: 'Öppna',
    leaveConfirm: 'Är du säker på att du vill lämna denna grupp?',
    postsTab: 'Inlägg',
    membersTab: 'Medlemmar',
    noPosts: 'Inga inlägg i denna grupp ännu',
    joinToSee: 'Gå med i gruppen för att se inlägg',
    about: 'Om gruppen',
    createdOn: 'Skapad',
    editGroup: 'Redigera grupp',
    deleteConfirm: 'Är du säker på att du vill ta bort denna grupp? Alla inlägg kommer att raderas.',
    setMember: 'Sätt som medlem',
    setModerator: 'Sätt som moderator',
    setAdmin: 'Sätt som admin',
    removeMember: 'Ta bort från grupp',
    removeMemberConfirm: 'Är du säker på att du vill ta bort {name} från gruppen?',
    changeCover: 'Byt omslagsbild',
    invalidImageType: 'Ogiltig filtyp. Välj en bild.',
    imageTooLarge: 'Bilden är för stor. Maximalt 5MB.'
  },
  profile: {
    title: 'Min profil',
    editProfile: 'Redigera profil',
    myPosts: 'Mina inlägg',
    myGroups: 'Mina grupper',
    overview: 'Översikt',
    edit: 'Redigera',
    settings: 'Inställningar',
    activity: 'Aktivitet',
    bio: 'Om mig',
    location: 'Plats',
    website: 'Webbplats',
    birthday: 'Födelsedag',
    interests: 'Intressen',
    joined: 'Gick med',
    posts: 'Inlägg',
    comments: 'Kommentarer',
    reactions: 'Reaktioner',
    privacy: 'Integritet',
    showRealName: 'Visa riktigt namn offentligt',
    showEmail: 'Visa e-post offentligt',
    emailNotifications: 'E-postnotifikationer',
    changePassword: 'Byt lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    uploadAvatar: 'Ladda upp profilbild',
    changeAvatar: 'Byt profilbild',
    removeAvatar: 'Ta bort profilbild',
    bioPlaceholder: 'Berätta lite om dig själv...',
    interestsPlaceholder: 'Vad är du intresserad av?',
    saveChanges: 'Spara ändringar',
    cancelChanges: 'Avbryt',
    profileUpdated: 'Profilen uppdaterad!',
    passwordChanged: 'Lösenordet ändrat!',
    avatarUploaded: 'Profilbild uppladdad!',
    recentPosts: 'Senaste inlägg',
    recentComments: 'Senaste kommentarer',
    recentReactions: 'Senaste reaktioner',
    noPosts: 'Inga inlägg ännu',
    noComments: 'Inga kommentarer ännu',
    noReactions: 'Inga reaktioner ännu',
    downloadData: 'Ladda ner mina data',
    deleteAccount: 'Radera konto',
    deleteAccountWarning: 'Detta kommer att permanent radera ditt konto och all data. Denna åtgärd kan inte ångras.',
    age: 'år'
  },
  common: {
    loading: 'Laddar...',
    error: 'Ett fel uppstod',
    success: 'Klart!',
    cancel: 'Avbryt',
    save: 'Spara',
    delete: 'Radera',
    edit: 'Redigera',
    post: 'Skicka',
    comment: 'Kommentar',
    quote: 'Citera',
    reply: 'Svara',
    confirm: 'Bekräfta',
    ok: 'OK',
    data: 'Data',
    noComments: 'Inga kommentarer ännu. Bli först!',
    writeComment: 'Skriv en kommentar...',
    replyToComment: 'Svara på kommentar...',
    deleteConfirm: 'Radera detta inlägg?',
    contentRequired: 'Innehållet kan inte vara tomt',
    updateFailed: 'Kunde inte uppdatera inlägg',
    deleteFailed: 'Kunde inte radera inlägg',
    commentFailed: 'Kunde inte skicka kommentar'
  },
  users: {
    searchTitle: 'Hitta användare',
    searchSubtitle: 'Sök efter användare i gemenskapen',
    searchPlaceholder: 'Sök efter användarnamn, namn eller e-post...',
    search: 'Sök',
    searchHint: 'Ange minst 2 tecken för att söka efter användare',
    resultsFound: '{count} användare hittade',
    noResults: 'Inga användare hittades. Prova ett annat sökord.'
  },
  validation: {
    required: 'Detta fält är obligatoriskt',
    email: 'Ange en giltig e-postadress',
    maxLength: 'Max {max} tecken',
    passwordMatch: 'Lösenorden måste matcha'
  }
}
